<template>
  <div>
    <v-flex layout align-center class="title pl-4" style="height: 80px">违章提交列表</v-flex>
    <l-data-card
      class="px-2"
      :headers="headers"
      :get-data="getItems"
      clickable
      @click:row="goDetails($event.item)"
    ></l-data-card>
  </div>
</template>

<script>
// import {VIOLATION_ROLE} from '../../object'

import LDataCard from '../../components/LDataCard'
import {VIOLATION_STATUS_TEXT} from '../../object'

export default {
  name: 'violationList',
  components: {LDataCard},
  data: vm => ({
    pageLoading: false,
    headers: [
      {
        text: '车辆号牌',
        value: 'plate',
        right: {
          value: 'status',
          f: v => VIOLATION_STATUS_TEXT[v]
        }
      },
      {text: '违章类型', value: 'typeName'},
      {text: '违章区域', value: 'area'},
      {text: '上报时间', value: 'creationTime', f: v => vm.$L.time.stringify(v)}
    ]
  }),
  computed: {},
  methods: {
    getItems ({pagination}) {
      return this.$store.dispatch('violation/getEvents', {
        pagination,
        self: true
      })
    },
    goDetails (item) {
      let selectionString = document.getSelection().toString()
      if (!selectionString) {
        this.$router.push({
          name: 'ViolationEventDetailsWX',
          params: {plate: item.plate, event: item},
          query: {id: item.id}
        })
      }
    }
  },
  created () {
  }
}
</script>

<style scoped>

</style>
